// import { paginationDataToShow } from "../actions/generalActions";
import {
  SUBCATEGORIES_CREATE_REQUEST,
  SUBCATEGORIES_CREATE_SUCCESS,
  SUBCATEGORIES_CREATE_FAIL,
  ALL_SUBCATEGORIES_VIEW_REQUEST,
  ALL_SUBCATEGORIES_VIEW_SUCCESS,
  ALL_SUBCATEGORIES_VIEW_FAIL,
  SUBCATEGORY_UPDATE_REQUEST,
  SUBCATEGORY_UPDATE_SUCCESS,
  SUBCATEGORY_UPDATE_FAIL,
  GROUP_SUBCATEGORIES_VIEW_REQUEST,
  GROUP_SUBCATEGORIES_VIEW_SUCCESS,
  GROUP_SUBCATEGORIES_VIEW_FAIL,
} from "../constants";

export const subCategoriesReducer = (
  state = {
    subCategories: {
      subCategories: null,
      from: null,
      to: null,
      groupSubCategories: null,
      loading: false,
    },
  },
  action
) => {
  switch (action.type) {
    case SUBCATEGORIES_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SUBCATEGORIES_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SUBCATEGORIES_CREATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // SUBCATEGORIES VIEW TABLE
    case ALL_SUBCATEGORIES_VIEW_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ALL_SUBCATEGORIES_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        subCategories: action.payload,
      };
    case ALL_SUBCATEGORIES_VIEW_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // SUBCATEGORY UPDATE
    case SUBCATEGORY_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SUBCATEGORY_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        // old code hata dya
        subCategories: state.subCategories.map((x) =>
          x.id == action.payload.id ? action.payload : x
        ),
      };
    case SUBCATEGORY_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GROUP_SUBCATEGORIES_VIEW_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GROUP_SUBCATEGORIES_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        groupSubCategories: action.payload,
      };
    case GROUP_SUBCATEGORIES_VIEW_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
